import { Pipe, PipeTransform } from '@angular/core';
@Pipe({name: 'checkNull'})
export class TransformDateNullPipe implements PipeTransform {
  transform(value: any) {
        return this.parseNull(value);
  }
  parseNull(value) {
    return value === null || value === undefined || value === ''  ? '-' : value;
  }
}